import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Heart } from 'lucide-react';
import { Button } from '../ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_hindu-service-hub/artifacts/wgibtr2f_Dharma%20Astra%20-%20Original%20%282%29.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/causes', label: 'Our Causes' },
    { path: '/volunteer', label: 'Volunteer' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 glass-header border-b border-gray-100" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="Dharma Astra Association" 
              className="w-14 h-14 object-contain"
            />
            <div className="hidden sm:block">
              <h1 className="font-heading text-xl font-bold text-gray-900">Dharma Astra</h1>
              <p className="text-xs text-gray-500 font-body">Association</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-body text-sm font-medium transition-colors link-underline ${
                  isActive(link.path) ? 'text-saffron' : 'text-gray-700 hover:text-saffron'
                }`}
                data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <Link to="/donate">
              <Button 
                className="bg-saffron hover:bg-saffron-dark text-white rounded-full px-6 py-2 font-body font-semibold btn-lift flex items-center gap-2"
                data-testid="donate-cta-button"
              >
                <Heart className="w-4 h-4" />
                Donate Now
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-gray-700 hover:text-saffron transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100" data-testid="mobile-nav">
          <nav className="px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-3 px-4 rounded-lg font-body text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? 'bg-saffron/10 text-saffron'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
                onClick={() => setIsMenuOpen(false)}
                data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/donate"
              className="block mt-4"
              onClick={() => setIsMenuOpen(false)}
            >
              <Button 
                className="w-full bg-saffron hover:bg-saffron-dark text-white rounded-full py-3 font-body font-semibold flex items-center justify-center gap-2"
                data-testid="mobile-donate-button"
              >
                <Heart className="w-4 h-4" />
                Donate Now
              </Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
